var render = function render(_c,_vm){return _c('value-activities-info',{staticClass:"my-3",attrs:{"infoData":_vm.props.row}})
}
var staticRenderFns = []

export { render, staticRenderFns }